import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "my-4 font-display text-2xl" }, "edit mode", -1)
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("confirm")
const _hoisted_4 = {
  key: 1,
  class: "mx-auto"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("search images")
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "pt-3" }, "click on image to select", -1)

import MyInput from "./MyInput.vue";
import MyButton from "./MyButton.vue";
import SquareImage from "./SquareImage.vue";
import Attribution from "./Attribution.vue";
import ImageSelectGrid from "./ImageSelectGrid.vue";
import { post } from "../server";
import { onMounted, Ref, ref } from "vue";
import { CardData } from "@/CardData";
import { ImageInfo } from "@/ImageInfo";
import { gtag } from "@/gtag";
import { store } from "@/store";


export default /*#__PURE__*/_defineComponent({
  props: {
  card: CardData,
},
  emits: ["finished"],
  setup(__props, { emit }) {

const props = __props

const searchImageText = ref("");
const images = ref(null);
const selectedImage: Ref<ImageInfo | null> = ref(null);
const loadingImages = ref(false);




onMounted(() => {
  const back = props.card?.back;
  if (!back) return;
  searchImageText.value = back;
});

function reset() {}

async function updateCard() {
  let editedCard = props.card;
  if (!editedCard) return;
  editedCard.image = selectedImage.value;

  post("card", {
    card: editedCard,
    sessionId: store.state.sessionId,
    updateImage: true,
  }).then((res) => {
    //returning card object in response
    console.log("response: " + JSON.stringify(res));
    //check if response is valid
    if (res.front) {
      store.commit("updateCard", res);
      emit("finished");
    }
  });

  gtag.event("updated-card-image");

  //commented out to test stuff
  reset();
}

async function searchImage() {
  loadingImages.value = true;
  let text = searchImageText;

  let json = await post("image/search", {
    text: text,
    sessionId: store.state.sessionId,
  });
  loadingImages.value = false;
  console.log(json);
  images.value = json.images;
}
function selectImage(image: ImageInfo) {
  selectedImage.value = image;
}

return (_ctx: any,_cache: any) => {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (selectedImage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(SquareImage, {
            image: selectedImage.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (selectImage(_ctx.image))),
            size: 60,
            class: "mt-4"
          }, null, 8, ["image"]),
          _createVNode(Attribution, {
            image: selectedImage.value,
            class: "mb-4"
          }, null, 8, ["image"]),
          _createVNode(MyButton, {
            class: "pt-3",
            onClickButton: _cache[1] || (_cache[1] = ($event: any) => (updateCard()))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(MyInput, {
            class: "pt-3",
            value: searchImageText.value,
            onInputText: _cache[2] || (_cache[2] = (x) => (searchImageText.value = x))
          }, null, 8, ["value"]),
          (!images.value)
            ? (_openBlock(), _createBlock(MyButton, {
                key: 0,
                class: "pt-3",
                onClickButton: _cache[3] || (_cache[3] = ($event: any) => (searchImage()))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (loadingImages.value)
            ? (_openBlock(), _createBlock(_component_loading, {
                key: 1,
                class: "my-4"
              }))
            : _createCommentVNode("", true),
          (images.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(ImageSelectGrid, {
                  onSelected: _cache[4] || (_cache[4] = (image) => selectImage(image)),
                  images: images.value
                }, null, 8, ["images"])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})